import { FetchState, LoadingState } from '../../utils/type';
import { fetchModuleFactory } from '../../utils/fetch-module-factory';
import { Structure } from '../../../models';

export interface FetchStructureState extends FetchState<Structure>, LoadingState {}
export const structureModule = fetchModuleFactory<Structure>('structure', true);
